module.exports = __webpack_public_path__ + "assets/media/logout.105c79cc.svg";